import { Subject } from "rxjs";

const QuestionnaireSubject = new Subject();

export { QuestionnaireSubject };



// WEBPACK FOOTER //
// ./src/shared/QuestionnaireSubject.js